var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ts-flex ts-items-center ts-absolute ts-right-0 ts-top-0 ts-mt-2",staticStyle:{"margin-right":"-27px"}},[_c('div',{staticClass:"ts-bg-gray-400 ts-w-2 ts-h-2 ts-rounded-full"}),_c('div',{staticClass:"ts-bg-yellow-700 ts-h-1",staticStyle:{"width":"14px"}}),_c('div',{staticClass:"ts-bg-gray-400 ts-w-2 ts-h-2 ts-rounded-full"})])
}]

export { render, staticRenderFns }